<template>
  <!-- STAR BOX -->
  <div :class="{'mt-50 mb-50': showStar}" class="container">
    <p v-if="showStar" class="center"><img src="~assets/img/star.png"></p>
    <p class="crowd-or-rais">
      <router-link to="/crowdfunding" class="crowd-or uppercase">{{ $t("project.crowdfunding") }}</router-link>
      <span class="or">{{ $t("whether") }}</span>
      <router-link to="/fundraising" class="rais-or uppercase">{{ $t("project.fundraising") }}?</router-link>
    </p>
  </div>
</template>

<script>
export default {
  props: { showStar: { type: Boolean, default: true } },
};
</script>



// WEBPACK FOOTER //
// CrowdOrRais.vue?19f42951